import {
  Box,
  Container,
  CssBaseline,
  Grid,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../config/theme";
import { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const allHeadings = [
  {
    headings: [
      {
        panel: "panel1",
        title: "Core Features",
        subheadings: [
          {
            subtitle: "Student Management",
            gridData: [
              { title: "Basic" },
              { title: "Advanced" },
              { title: "Enterprise" },
            ],
          },
          {
            subtitle: "Attendance Tracking",
            gridData: [
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Grade Management",
            gridData: [
              { title: "Manual" },
              { title: "Automated" },
              { title: "AI-Powered" },
            ],
          },
          {
            subtitle: "Parent Communication",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
      {
        panel: "panel2",
        title: "Financial Management",
        subheadings: [
          {
            subtitle: "Fee Collection",
            gridData: [
              { title: "Basic" },
              { title: "Advanced" },
              { title: "Enterprise" },
            ],
          },
          {
            subtitle: "Payment Processing",
            gridData: [
              { title: "Manual" },
              { title: "Online" },
              { title: "Multi-Gateway" },
            ],
          },
          {
            subtitle: "Financial Reports",
            gridData: [
              { title: <CancelIcon /> },
              { title: "Basic" },
              { title: "Advanced" },
            ],
          },
          {
            subtitle: "Expense Tracking",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
      {
        panel: "panel3",
        title: "Analytics & Reporting",
        subheadings: [
          {
            subtitle: "Student Performance",
            gridData: [
              { title: <CancelIcon /> },
              { title: "Basic" },
              { title: "Advanced" },
            ],
          },
          {
            subtitle: "Attendance Analytics",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Financial Analytics",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Custom Reports",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
      {
        panel: "panel4",
        title: "Communication Tools",
        subheadings: [
          {
            subtitle: "Email Notifications",
            gridData: [
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "SMS Alerts",
            gridData: [
              { title: <CancelIcon /> },
              { title: "Limited" },
              { title: "Unlimited" },
            ],
          },
          {
            subtitle: "Mobile App",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Video Conferencing",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
    ],
  },
  {
    headings: [
      {
        panel: "panel5",
        title: "Administrative Tools",
        subheadings: [
          {
            subtitle: "User Management",
            gridData: [
              { title: "5 Users" },
              { title: "25 Users" },
              { title: "Unlimited" },
            ],
          },
          {
            subtitle: "Role-Based Access",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Data Backup",
            gridData: [
              { title: "Manual" },
              { title: "Daily" },
              { title: "Real-time" },
            ],
          },
          {
            subtitle: "API Access",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
      {
        panel: "panel6",
        title: "Canteen Management",
        subheadings: [
          {
            subtitle: "Menu Management",
            gridData: [
              { title: <CancelIcon /> },
              { title: "Basic" },
              { title: "Advanced" },
            ],
          },
          {
            subtitle: "Order Processing",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Inventory Tracking",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Payment Integration",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
      {
        panel: "panel7",
        title: "Support & Training",
        subheadings: [
          {
            subtitle: "Email Support",
            gridData: [
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Phone Support",
            gridData: [
              { title: <CancelIcon /> },
              { title: "Business Hours" },
              { title: "24/7" },
            ],
          },
          {
            subtitle: "Training Sessions",
            gridData: [
              { title: <CancelIcon /> },
              { title: "2 Sessions" },
              { title: "Unlimited" },
            ],
          },
          {
            subtitle: "Dedicated Manager",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
      {
        panel: "panel8",
        title: "Security & Compliance",
        subheadings: [
          {
            subtitle: "Data Encryption",
            gridData: [
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "GDPR Compliance",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Audit Logs",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "SSO Integration",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
    ],
  },
  {
    headings: [
      {
        panel: "panel9",
        title: "Advanced Features",
        subheadings: [
          {
            subtitle: "AI-Powered Insights",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Predictive Analytics",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Custom Integrations",
            gridData: [
              { title: <CancelIcon /> },
              { title: "Limited" },
              { title: "Unlimited" },
            ],
          },
          {
            subtitle: "White-label Solution",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
      {
        panel: "panel10",
        title: "Storage & Limits",
        subheadings: [
          {
            subtitle: "Data Storage",
            gridData: [
              { title: "1 GB" },
              { title: "10 GB" },
              { title: "Unlimited" },
            ],
          },
          {
            subtitle: "Student Records",
            gridData: [
              { title: "100" },
              { title: "1,000" },
              { title: "Unlimited" },
            ],
          },
          {
            subtitle: "File Upload Size",
            gridData: [
              { title: "5 MB" },
              { title: "25 MB" },
              { title: "100 MB" },
            ],
          },
          {
            subtitle: "Backup Retention",
            gridData: [
              { title: "7 Days" },
              { title: "30 Days" },
              { title: "1 Year" },
            ],
          },
        ],
      },
      {
        panel: "panel11",
        title: "Integration Options",
        subheadings: [
          {
            subtitle: "LMS Integration",
            gridData: [
              { title: <CancelIcon /> },
              { title: "Basic" },
              { title: "Advanced" },
            ],
          },
          {
            subtitle: "Accounting Software",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Third-party Apps",
            gridData: [
              { title: <CancelIcon /> },
              { title: "Limited" },
              { title: "Unlimited" },
            ],
          },
          {
            subtitle: "Custom API",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
      {
        panel: "panel12",
        title: "Deployment Options",
        subheadings: [
          {
            subtitle: "Cloud Hosting",
            gridData: [
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "On-Premise",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Hybrid Deployment",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Multi-tenant",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
    ],
  },
];

const Features = ({ active }) => {
  const [expanded, setExpanded] = useState([]);
  useEffect(() => {
    const initialExpanded = allHeadings.map((item) => item.headings[0].panel);
    setExpanded(initialExpanded);
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded((prevExpanded) => {
      if (isExpanded) {
        return prevExpanded.includes(panel)
          ? prevExpanded
          : [...prevExpanded, panel];
      } else {
        return prevExpanded.filter((p) => p !== panel);
      }
    });
  };

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container>
        <Box sx={{ display: { xs: "none", sm: "block" } }}>
          {allHeadings.map((item, index) => (
            <Box
              key={index}
              sx={{
                marginTop: "3.75rem",
                display: active === index ? "block" : "none",
              }}
            >
              {item.headings.map((item, index) => (
                <Accordion
                  key={index}
                  expanded={expanded.includes(item.panel)}
                  onChange={handleChange(item.panel)}
                  sx={{
                    boxShadow: "none",
                    borderBottom: `1px solid ${theme.palette.primary.main}`,
                    "&.Mui-expanded": {
                      margin: 0,
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon
                        sx={{ color: `${theme.palette.primary.main}` }}
                      />
                    }
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: `${theme.palette.primary.main}`,
                        fontSize: "1.25rem",
                        letterSpacing: "0.01rem",
                        fontWeight: 700,
                      }}
                    >
                      {item.title}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {item.subheadings.map((subheading, subIndex) => (
                        <Box
                          key={subIndex}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Box sx={{ display: "flex", flex: 1 }}>
                            <Typography
                              variant="h6"
                              sx={{
                                fontSize: "1.25rem",
                                fontWeight: 700,
                                letterSpacing: "0.01rem",
                                color: "#212121",
                              }}
                            >
                              {subheading.subtitle}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", flex: 3 }}>
                            <Grid container spacing={2}>
                              {subheading.gridData.map((item, index) => (
                                <Grid item xs={4} key={index}>
                                  <Box
                                    sx={{
                                      border: ` 0.4px solid ${theme.palette.primary.main}`,
                                      height: "3rem",
                                      width: "15.5rem",
                                      marginBottom: "0.75rem",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        margin: "0.75rem",
                                        fontSize: "0.875rem",
                                      }}
                                    >
                                      {item.title}
                                    </Box>
                                  </Box>
                                </Grid>
                              ))}
                            </Grid>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            marginTop: ["2.5rem", "3.75rem"],
            marginBottom: ["3.75rem", "8.125rem"],
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: ["0.75rem", "1.25rem"],
              fontWeight: 400,
              letterSpacing: ["0.0079055rem", "0.01rem"],
              color: "#212121",
              ...(isMobile && {
                textAlign: "center",
              }),
            }}
          >
            Transform your educational institution with our comprehensive platform. From student management to financial analytics, we provide all the tools you need to succeed in today's digital learning environment.
          </Typography>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default Features;
